import OutstadingSearchForm from '../model/form.model';

class FormController {
  $onInit() {
    this.OutstadingSearchForm = OutstadingSearchForm;
  }

  submit() {
    this.onSubmit({payload: this.OutstadingSearchForm.toPayload()});
  }
}

export default FormController;



// WEBPACK FOOTER //
// ./client/app/pages/customer/outstandingbet/component/form.controller.js